import type { ConnectInterface } from 'walden-fast/types/connect-interface';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_CONNECT_INTERFACE: ConnectInterface = {
  lastUpdated: new Date(1732721945000).toISOString(),
  interfaceName: 'Walden / Walden (WAL)',
  isActive: true,
  counter: 123,
};

export const connectInterfaceFactory: Factory<ConnectInterface> = (
  overrides,
) => ({
  ...MOCK_CONNECT_INTERFACE,
  ...overrides,
});

export const mockConnectInterfaces = (): ConnectInterface[] => [
  {
    lastUpdated: '2025-09-29T11:44:15.804949Z',
    interfaceName: 'Walden / Walden (WAL)',
    isActive: true,
    counter: 123,
  },
  {
    lastUpdated: '2025-09-28T10:30:00.000000Z',
    interfaceName: 'Advanced Shipping Notification (ASN)',
    isActive: false,
    counter: 45,
  },
  {
    lastUpdated: '2025-09-27T15:20:30.500000Z',
    interfaceName: 'Goods Receipt Notification (GRN)',
    isActive: true,
    counter: 78,
  },
  {
    lastUpdated: null,
    interfaceName: 'Delivery Order',
    isActive: false,
    counter: null,
  },
  {
    lastUpdated: '2025-09-26T09:15:45.200000Z',
    interfaceName: 'Dispatch Confirmation',
    isActive: true,
    counter: 156,
  },
  {
    lastUpdated: '2025-09-25T14:22:10.800000Z',
    interfaceName: 'Shipment Orders',
    isActive: true,
    counter: 234,
  },
  {
    lastUpdated: null,
    interfaceName: 'Delivery Status',
    isActive: false,
    counter: null,
  },
  {
    lastUpdated: '2025-09-24T11:33:25.100000Z',
    interfaceName: 'Invoice/Credit note',
    isActive: true,
    counter: 89,
  },
  {
    lastUpdated: '2025-09-23T16:45:30.600000Z',
    interfaceName: 'Quality Status Change',
    isActive: true,
    counter: 67,
  },
  {
    lastUpdated: null,
    interfaceName: 'Stock level',
    isActive: false,
    counter: null,
  },
  {
    lastUpdated: '2025-09-22T08:12:15.300000Z',
    interfaceName: 'Returned Materials Received',
    isActive: true,
    counter: 34,
  },
];

export const mockEmptyConnectInterfaces = (): ConnectInterface[] => [];
